import { render } from "./blogLayout.vue?vue&type=template&id=83bf438e&scoped=true&ts=true"
import script from "./blogLayout.vue?vue&type=script&lang=ts"
export * from "./blogLayout.vue?vue&type=script&lang=ts"

import "./blogLayout.vue?vue&type=style&index=0&id=83bf438e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83bf438e"]])

export default __exports__